<template>
  <div class="preferredBrand-info">
    <div class="topHeader">
      <div class="btns">
        <div
          class="btn"
          v-for="(item, index) in headerLinkList"
          :key="index"
          @click="toLink(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <!-- 视频列表 -->
    <TopVideoList
      :videoList="videoList"
      :dataSource="dataSource"
    ></TopVideoList>
    <!-- 品牌信息 -->
    <div class="base-info area">
      <div class="title1">{{ dataSource.name }}</div>
      <div class="subTitle1">{{ dataSource.companyName }}</div>
      <div class="desc">
        {{ dataSource.introduce }}
      </div>

      <div class="phone" v-if="dataSource.categoryContactPersonPhone">
        联系我们：{{ dataSource.categoryContactPersonPhone }}
        {{
          dataSource.categoryContactPerson &&
          `(${dataSource.categoryContactPerson})`
        }}
      </div>
    </div>
    <!-- 产品介绍 -->
    <div class="product-info" v-if="productList && productList.length">
      <div class="area">
        <div>
          <div class="title2">产品介绍</div>
          <div class="subTitle2">PRODUCT INTRODUCTION</div>
        </div>
        <!-- 走马灯 -->
        <ProductCarousel
          :productList="productList"
          :dataSource="dataSource"
        ></ProductCarousel>
      </div>
    </div>
    <div class="auth-info" v-if="authorizedList && authorizedList.length">
      <div class="area">
        <div>
          <div class="title1">授权凭证</div>
          <div class="subTitle1">AUTHORIZATION CERTIFICATE</div>
        </div>
        <AuthList class="mt-48" :authorizedList="authorizedList"></AuthList>
      </div>
    </div>
    <div class="fileArea" v-if="fileList && fileList.length">
      <img
        class="fileImg"
        v-for="item in fileList"
        :key="item.url"
        :src="item.url"
        :width="item.width"
      />
    </div>
  </div>
</template>

<script>
import ProductCarousel from "./components/productCarousel.vue";
import AuthList from "./components/authList.vue";
import TopVideoList from "./components/topVideoList.vue";

export default {
  components: { ProductCarousel, AuthList, TopVideoList },
  data() {
    return {
      dataSource: {
        fileItemList: [],
      },
      headerLinkList: [
        {
          label: "首页",
          link: "/",
        },
        {
          label: "精品商城",
          link: "/premium",
        },
        {
          label: "联储联备",
          link: "/storeSpare",
        },
        {
          label: "优选品类",
          link: "/preferredBrand",
        },
      ],
    };
  },
  mounted() {
    this.getInfo();
  },
  computed: {
    // 产品信息
    productList() {
      return (this.dataSource.fileItemList || []).filter((i) => i.type === "1");
    },
    // 授权信息
    authorizedList() {
      return (this.dataSource.fileItemList || []).filter((i) => i.type === "2");
    },
    // 视频文件
    videoList() {
      return (this.dataSource.fileItemList || []).filter((i) => i.type === "3");
    },
    // 附件文件
    fileList() {
      return (this.dataSource.fileItemList || [])
        .filter((i) => i.type === "4")
        .map((i) => {
          return i.imgUrlList.map((j) => {
            return { url: j, width: i.width || "1200px" };
          });
        })
        .flat(1);
    },
  },
  methods: {
    toLink(res) {
      window.open(res.link, "_blank");
    },
    getInfo() {
      this.$http
        .post(
          `/front/cross/commodity-user/brand/premiumBrandDetail?premiumBrandId=${
            this.$route.query.premiumBrandId || null
          }`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            console.log(res.data);

            this.dataSource = res.data;
          }
        });
    },
  },
  beforeDestroy() {
    window.onreset = () => {};
  },
  beforeCreate() {
    console.log("beforeCreate");
    window.onresize = jumpLink;
    jumpLink();
    function jumpLink() {
      const w = window.screen.width;
      const minWidth = 900;
      if (w < minWidth) {
        const host = window.location.host;
        const urlArr = window.location.search.split("?");
        const query = Object.fromEntries(
          (urlArr[1] || "").split("&").map((i) => i.split("="))
        );

        if (host.includes("10.10.56") || host.includes("localhost")) {
          window.location.href =
            window.location.protocol +
            "//" +
            window.location.hostname +
            ":5000/#/pages/preferredBrand/info?premiumBrandId=" +
            query.premiumBrandId;
        } else if (host.includes("predev")) {
          window.location.href =
            "http://predevm.plantmate.supcon.com:8888/#/pages/preferredBrand/info?premiumBrandId=" +
            query.premiumBrandId;
        } else if (host.includes("pretest")) {
          window.location.href =
            "http://pretestm.plantmate.supcon.com:8888/#/pages/preferredBrand/info?premiumBrandId=" +
            query.premiumBrandId;
        } else if (host.includes("uat2")) {
          window.location.href =
            "https://uat2m-plantmate.supcon.com:8888/#/pages/preferredBrand/info?premiumBrandId=" +
            query.premiumBrandId;
        } else {
          window.location.href =
            "https://m.plantmate.com/#/pages/preferredBrand/info?premiumBrandId=" +
            query.premiumBrandId;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.preferredBrand-info {
  font-family: Alibaba PuHuiTi;
  min-width: 1240px;
  .area {
    width: 1200px;
    margin: 0 auto;
  }

  .title1 {
    font-size: 32px;
    font-weight: bold;
    color: #080404;
  }
  .subTitle1 {
    font-size: 16px;
    text-transform: uppercase;
    color: #080404;
    opacity: 0.3;
  }
  .desc {
    margin-top: 8px;
    font-size: 16px;
    line-height: 32px;
    color: rgba(8, 4, 4, 0.5);
  }
  .phone {
    margin-top: 40px;
    font-size: 24px;
    color: #2a54d1;
  }
  .title2 {
    font-size: 32px;
    font-weight: bold;
    color: #ffffff;
  }
  .subTitle2 {
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    color: #ffffff;
    opacity: 0.3;
  }
  .base-info {
    padding: 40px 0;
  }

  .product-info {
    background: #2a54d1;
    padding: 50px 0;
  }
  .auth-info {
    padding: 50px 0;
    height: 708px;
    background-image: url("~@/assets/img/preferredBrand/bg_line.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 0 50%;
  }
  .mt-48 {
    margin-top: 48px;
  }
  .fileArea {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .fileImg {
    max-width: 100%;
  }
  .topHeader {
    position: sticky;
    top: 0;
    height: 64px;
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #ffffff;
    backdrop-filter: blur(10px);
    z-index: 1000;
    .btns {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      .btn {
        width: 152px;
        height: 64px;
        padding: 10px;
        text-align: center;
        line-height: 44px;
        box-sizing: border-box;
        font-size: 20px;
        color: #080404;
        cursor: pointer;
        &:hover {
          color: #2a54d1;
          border-width: 0px 0px 3px 0px;
          border-style: solid;
          border-color: #2a54d1;
        }
      }
    }
  }
}
</style>
